<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
  time: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData,props.time);
});


function initChart(listData,time) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let xLabel = [ '2023/10', '2023/11', '2023/12', '2024/01', '2024/02', '2024/03'];
  let data=[
    {name:"山东",value:[1.6,1.5,1.56,1.56,1.7,1.9]},
    {name:"河南",value:[1.25,1.3,1.2,1.3,1.4,1.5]},
    {name:"河北",value:[1.36,1.2,1.3,1.39,1.46,1.4]},
    {name:"湖北",value:[1.4,1.36,1.38,1.38,1.6,1.3]},
    {name:"广东",value:[2.00,1.8,1.78,1.75,1.62,1.68]},
  ]

  const option= {
    color: [
      {
        x: 1,
        y: 0,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0,
          color: 'rgba(35, 194,134, 0.02)'
        },
          {
            offset: 0.3,
            color: 'rgba(35, 194,134, 1)'
          },
          {
            offset: 0.8,
            color: 'rgba(35, 194,134,1)'
          },
          {
            offset: 1,
            color: 'rgba(35, 194,134, 0.02)'
          }],
      },
      {
        x: 1,
        y: 0,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0,
          color: 'rgba(18, 114,211, 0.02)'
        },
          {
            offset: 0.3,
            color: 'rgba(18, 114,211, 1)'
          },
          {
            offset: 0.8,
            color: 'rgba(18, 114,211, 1)'
          },
          {
            offset: 1,
            color: 'rgba(18, 114,211, 0.02)'
          }],
      },
      {
        x: 1,
        y: 0,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0,
          color: 'rgba(26, 171,166, 0.02)'
        },
          {
            offset: 0.3,
            color: 'rgba(26, 171,166,1)'
          },
          {
            offset: 0.8,
            color: 'rgba(26, 171,166, 1)'
          },
          {
            offset: 1,
            color: 'rgba(26, 171,166, 0.02)'
          }],
      },
      {
        x: 1,
        y: 0,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0,
          color: 'rgba(184, 140,49, 0.02)'
        },
          {
            offset: 0.3,
            color: 'rgba(184, 140,49, 1)'
          },
          {
            offset: 0.8,
            color: 'rgba(184, 140,49, 1)'
          },
          {
            offset: 1,
            color: 'rgba(184, 140,49, 0.02)'
          }],
      },
      {
        x: 1,
        y: 0,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0,
          color: 'rgba(106, 158,226, 0.02)'
        },
          {
            offset: 0.3,
            color: 'rgba(106, 158,226, 1)'
          },
          {
            offset: 0.8,
            color: 'rgba(106, 158,226, 1)'
          },
          {
            offset: 0.9,
            color: 'rgba(106, 158,226, 1)'
          },
          {
            offset: 1,
            color: 'rgba(106, 158,226, 0.02)'
          }],
      }
      ],
    tooltip: {
      trigger: 'axis',
      // backgroundColor: 'rgba(0,0,0,0.5)',
      // borderColor: '#34CEFFBD',
      borderWidth: 2,
      padding: [5, 10],
      textStyle: {
        fontSize: 26
      },
      formatter: (params) => {
          // console.log('params',params)
          let str = `${params[0].name}年<br/>`;
          //seriesName color value
          for (let i = 0; i < params.length; i++) {
              str =
                  str +
                  `<span style='display:inline-block;margin-right:5px;
              border-radius:10px;width:9px;height:9px;background-color:${params[i].color}'></span>
              ${params[i].seriesName}：<i style='float:right;color:${params[i].color}' >${params[i].value}%</i><br/>`;
          }
          return str;
      },
    },
    legend: {
      align: 'left',
      right: '10%',
      top: '5%',
      type: 'plain',
      textStyle: {
        color: '#fff',
        fontSize: 26,
      },
      icon:'circle',
      itemGap: 30,
      itemWidth: 18,
      // icon: 'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
    },
    grid: {
      top: '18%',
      left: '8%',
      right: '10%',
      bottom: '8%',
      // containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '',
        nameGap: 10,
        boundaryGap: false,
        nameTextStyle: {
          // ---坐标轴名称样式
          color: '#E2E8EDE8',
          fontSize: 26,
        },
        axisLabel: {
          show: true,
          interval: 0, //横轴信息全部显示
          // rotate:-30,//-30度角倾斜显示
          textStyle: {
            color: '#E2E8EDE8', // 更改坐标轴文字颜色
            fontSize:26 // 更改坐标轴文字大小
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#379E98AB',
          },
        },
        axisTick: {
          show: false,
        },
        data: time,
      },
    ],
    yAxis: [
      {
        min: 1, // 坐标轴刻度最小值。
        // max: 3, // 坐标轴刻度最大值。
        splitNumber:3,
        splitLine: {
          show: true,
          lineStyle: {
            type: [5,10],
            dashOffset: 10,
            color: 'rgba(18,130,200,.8)',
            fontSize:30
          }
        },
        axisLabel: {
          show: true,
          interval: 0, //横轴信息全部显示
          textStyle: {
            color: 'rgba(255,255,255,.5)', // 更改坐标轴文字颜色
            fontSize:26 // 更改坐标轴文字大小
          },
          formatter: function(value) {
            // 当值为 0 时不显示标签
            return value === 1 ? '' : value;
          }
        },
      },
    ],
    series: [
      {
        name: listData[0].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 0,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 1,
        },
        tooltip: {
          show: true,
        },
        data: data[0].value,
      },
      {
        name: listData[1].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize:0,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: listData[1].value,
      },
      {
        name: listData[2].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 0,
        smooth: true,
        lineStyle: {
          normal: {
            width: 6,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: listData[2].value,
      },
      {
        name: listData[3].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 0,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: listData[3].value,
      },
      {
        name: listData[4].name,
        type: 'line',
        symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        showAllSymbol: true,
        symbolSize: 0,
        smooth: true,
        lineStyle: {
          normal: {
            width: 5,
          },
          borderColor: 'rgba(0,0,0,.4)',
        },
        itemStyle: {
          borderWidth: 2,
        },
        tooltip: {
          show: true,
        },
        data: listData[4].value,
      },
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
